import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Recommendations/CampaignsRecommendations/Type/subcomponents/List/list.module.scss'
import formatMoney from 'utils/formatMoney'

export default ({ setSorting, setColumnVisibility, ...rest }) => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()

  useEffect(() => {
    switch (true) {
      case breakpoints.sm:
        setColumnVisibility({})
        break
      case breakpoints.md:
        setColumnVisibility({})
        break
      default:
        setColumnVisibility()
        break
    }
  }, [breakpoints])

  return {
    columns: [
      {
        id: 'account_login',
        accessorKey: 'account_login',
        header: t(
          'recommendations::type.campaign-budget.table.head.account_login.label',
        ),
        cell: ({
          row: {
            original: { account_login },
          },
        }) => account_login ?? '',
      },
      {
        id: 'campaign_id',
        accessorKey: 'campaign_id',
        header: t(
          'recommendations::type.campaign-budget.table.head.campaign_id.label',
        ),
        cell: ({
          row: {
            original: { campaign_id },
          },
        }) => campaign_id ?? '',
      },
      {
        id: 'type',
        header: t('recommendations::type.action-cost.table.head.type.label'),
        cell: ({
          row: {
            original: { type, platform },
          },
        }) => (
          <span>
            {type} (
            {t(`recommendations::type.filters.platforms.options.${platform}`)})
          </span>
        ),
      },
      {
        id: 'cost',
        accessorKey: 'cost',
        header: t(
          'recommendations::type.campaign-budget.table.head.cost.label',
        ),
        cell: ({
          row: {
            original: { cost },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{ __html: formatMoney(cost, 'RUB') }}
          />
        ),
      },
      {
        id: 'up_to_budg_cnt',
        header: t(
          'recommendations::type.campaign-budget.table.head.up_to_budg_cnt.label',
        ),
        cell: ({
          row: {
            original: { up_to_budg_cnt },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(up_to_budg_cnt, 'RUB'),
            }}
          />
        ),
      },
      {
        id: 'week_budget',
        header: t(
          'recommendations::type.campaign-budget.table.head.week_budget.label',
        ),
        cell: ({
          row: {
            original: { week_budget },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(week_budget, 'RUB'),
            }}
          />
        ),
      },
      {
        id: 'day_budget',
        header: t(
          'recommendations::type.campaign-budget.table.head.day_budget.label',
        ),
        cell: ({
          row: {
            original: { day_budget },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(day_budget, 'RUB'),
            }}
          />
        ),
      },
      {
        id: 'pay_for_conversion',
        header: t(
          'recommendations::type.campaign-budget.table.head.pay_for_conversion.label',
        ),
        cell: ({
          row: {
            original: { pay_for_conversion },
          },
        }) =>
          t(
            'recommendations::type.campaign-budget.table.pay_for_conversion.value',
            { context: pay_for_conversion.toString() },
          ),
      },
      {
        id: 'strategy_type',
        header: t(
          'recommendations::type.action-cost.table.head.strategy_type.label',
        ),
        cell: ({
          row: {
            original: { strategy_type },
          },
        }) =>
          t(
            `recommendations::type.filters.strategy_types.options.${strategy_type}`,
          ),
      },
      {
        id: 'account_external_id',
        header: t(
          'recommendations::type.campaign-budget.table.head.account_external_id.label',
        ),
        cell: ({
          row: {
            original: { account_external_id = '' },
          },
        }) => account_external_id,
      },
    ],
    showHeader: true,
    showFooter: false,
    onSortingChange: setSorting,
    onColumnVisibilityChange: setColumnVisibility,
    className: styles['table'],
    getRowId: ({ external_id }) => external_id,
    ...rest,
  }
}
